var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
// Per account, what stops its delivery reports (and Messenger's Get Started)
// from reaching Step: `callback_readiness`, read with messaging-config-read or
// messaging-account-read.
export var GET_MESSAGING_CALLBACK_STATUS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetMessagingCallbackStatus {\n        messaging_callback_status {\n            accounts {\n                account_id\n                blockers\n                reasons\n            }\n        }\n    }\n"], ["\n    query GetMessagingCallbackStatus {\n        messaging_callback_status {\n            accounts {\n                account_id\n                blockers\n                reasons\n            }\n        }\n    }\n"])));
var templateObject_1;
